<div class="row">
  <div class="col-md-6 col-md-offset-3">
    <p *ngIf="internal" style="font-style: italic">
      Please wait. Attempting login through single sign on.
    </p>
    <p *ngIf="!internal" style="font-style: italic">
      <STRONG>Please wait for login.</STRONG>
    </p>
  </div>
</div> <!--End Service Container-->